<div [ngClass]="{ 'timeline-label-container': true, dashed: status === 'pending', solid: status === 'finished' }">
  <div *ngIf="type === 'breakpoint'" class="timeline-label-breakpoint"></div>
  <img *ngIf="type === 'alert'" class="timeline-label-alert" src="assets/icons/error.svg" />
  <img *ngIf="type === 'success'" class="timeline-label-success" src="assets/icons/success.svg" />
  <div class="timeline-label-content-container">
    <div [ngClass]="{ 'timeline-label-name': true, alert: type === 'alert' }">{{ name }}</div>
    <div [ngClass]="{ 'timeline-label-date': true, alert: type === 'alert' }">{{ date | date: 'dd/MM' }}</div>
  </div>
</div>
